import {PricingItem} from "../../../../domain/in/quote/pricing-item/pricing-item";
import {PricingItemSummary} from "../../../../domain/out/pricing-item-summary";
import {TranslationServiceInterface} from "../../../translation-service.interface";
import {MappingContext} from "./mapping-context";

export abstract class AbstractPricingItemSummaryMapper {

    constructor(protected translationService: TranslationServiceInterface) {
    }

    pricingItemToProductItemSummary(pricingItem: PricingItem, currency: string, locale: string): Promise<PricingItemSummary> {
        const ctx = new MappingContext(this.translationService, currency, locale);
        return this.doMap(pricingItem, ctx);
    }

    protected abstract doMap(pricingItem: PricingItem, ctx: MappingContext): Promise<PricingItemSummary>;
}
